import React, { ReactNode } from 'react';
import AuthContext from 'contexts/AuthContext';
import { useAuth } from 'hooks/useAuth';

type Props = {
    children: ReactNode;
};

function AuthProvider({ children }: Props) {
    const auth = useAuth();

    return <AuthContext.Provider value={auth}>{children}</AuthContext.Provider>;
}

export default AuthProvider;
